import type { DomainDataProfile } from '../../core/data-profiles';
import {
  processHydrator,
  type ProcessEdgeType,
  type ProcessNodeType,
  type ProcessUniversalEdgeProps,
  type ProcessUniversalNodeProps,
} from './interop/ProcessHydrator';
import { projectProcessScenario } from './scenarios/processScenarioProjector';

export const ProcessProfile: DomainDataProfile<ProcessNodeType, ProcessEdgeType, ProcessUniversalNodeProps, ProcessUniversalEdgeProps> = {
  domainId: 'process',
  profileVersion: '1.0',
  diagramTypes: ['flowchart'],
  nodeTypes: ['process', 'decision', 'terminator', 'data', 'document', 'flowchart-shape', 'bpmn-shape'],
  edgeTypes: ['sequence_flow'],
  vocabulary: {
    recordSingular: 'Process Step',
    recordPlural: 'Process Steps',
    repositoryLabel: 'Process Repository',
    hierarchyLabel: 'Parent Process',
    importAction: 'Import Process Map',
    keyColumnHint: 'Process ID',
    commitLabel: 'Commit to Repository',
    pullLabel: 'Pull Latest',
    diagramLabel: 'process map',
  },
  fieldAliases: {
    processId: ['id', 'ID', 'process_id', 'processId', 'key', 'unique_id'],
    name: ['name', 'Name', 'title', 'Title', 'label', 'process_name', 'processName'],
    parentProcessId: ['parent_id', 'parentId', 'parent', 'parent_process', 'parent_process_id'],
    status: ['status', 'Status', 'state', 'process_status'],
    owner: ['owner', 'Owner', 'assigned_to'],
    description: ['description', 'Description', 'desc'],
  },
  requiredProps: ['processId', 'name'],
  recommendedProps: ['parentProcessId'],
  hierarchyConfig: {
    type: 'single-parent',
    parentProp: 'parentProcessId',
    edgeSubtype: 'sequence_flow',
  },
  primaryShapeType: 'process',
  propsToAttrsMapping: {
    processId: 'processId',
    name: 'name',
    status: 'status',
    owner: 'owner',
    description: 'description',
  },
  hydrator: processHydrator,
  shapeBinding: {
    onNewEntityShape: 'auto-bind',
    onReadOnlySource: 'diagram-only',
  },
  relationshipMappings: [
    {
      pattern: 'edge-table',
      edgeType: 'sequence_flow',
      tableId: 'flows',
      sourceField: 'from_process',
      targetField: 'to_process',
      typeField: 'flow_type',
      additionalFields: ['label', 'condition'],
    },
  ],
  scenarioConfig: {
    supportedOperations: ['add', 'remove', 'move', 'update'],
    trackableProps: ['processId', 'name', 'status', 'owner', 'description', 'parentProcessId'],
    projector: (baseNodes, baseEdges, delta) =>
      projectProcessScenario(baseNodes, baseEdges, delta as Parameters<typeof projectProcessScenario>[2]),
  },
  chromeConfig: {
    hiddenTools: [],
    searchTarget: 'steps',
  },
  onboardingModes: ['blank', 'capture', 'demo', 'template'],
};
